import { getLocalStorage, setLocalStorage } from '../../../helpers/localStorage';

const FORM_LOCAL_STORAGE_PATH = 'current-report';
export type LocalStorageReport = {
	id?: number,
	name: string,
	report?: {report: Report, id: number, name: string},
};

type LocalStorageReportWrapper = {
	[key: number]: LocalStorageReport,
	newReport?: LocalStorageReport
}

function getLocalReport(): LocalStorageReportWrapper | undefined {
	return getLocalStorage(FORM_LOCAL_STORAGE_PATH);
}

export function setLocalReport(report: LocalStorageReport, id?: number) {
	const actualReport = getLocalReport() ?? {};
	if (id === undefined) return setLocalStorage(FORM_LOCAL_STORAGE_PATH, { ...actualReport, report });
	actualReport[id] = report;
	setLocalStorage(FORM_LOCAL_STORAGE_PATH, { ...actualReport });
}
